import React from 'react'
import { FormattedMessage } from 'react-intl'

export default ({ id }) => (
  <div style={{ textAlign: 'center' }}>
    <FormattedMessage id={id} />
  </div>
)